<style lang="scss" scoped>
h2 {
    word-break: break-word;
    hyphens: auto;
}
.width-cap {
    @media screen and (min-width: 1280px) {
        max-width: 240px;
    }
}
h4 .mb-24{
    font-size: 1.5rem;
}
h4 .mb-16{
    font-size: 1.5rem;
}
.top {
    top: 0;
}
</style>

<template>
    <div class="container-fluid">
        <div class="row d-block position-relative">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-xl-6 mb-40 mb-lg-80 mb-xl-120">
                        <h2 class="mb-16 mt-24 mt-md-40 mt-xl-80">{{contact.form.title}}</h2>
                        <p class="mb-40 mb-xl-80 font-weight-light">{{contact.form.description}}</p>
                        <el-contact-form></el-contact-form>
                    </div>
                </div>
            </div>
            <div class="col-12 top col-xl-5 offset-xl-7 bg-dark py-40 py-md-56 pt-xl-80 pl-xl-96 text-white position-xl-absolute h-100">
                <div class="px-12 px-md-24 px-xl-0">
                    <div class="d-none d-xl-block">

                        <div class="richtext" v-html="contact.contact"></div>

                        <span class="mb-16 d-block">Social</span>
                        <div class="mb-40">
                            <a href="https://www.facebook.com/tothepointevents/" target="_blank" rel="noopener"><span v-html="svg('icon-facebook', 'mr-16')"></span></a>
                            <a href="https://www.instagram.com/tothepointevents" target="_blank" rel="noopener"><span v-html="svg('icon-instagram', 'mr-16')"></span></a>
                            <a href="https://twitter.com/ttpointevents" target="_blank" rel="noopener"><span v-html="svg('icon-twitter', 'mr-16')"></span></a>
                            <a href="https://www.linkedin.com/company/to-the-point-events/" target="_blank" rel="noopener"><span v-html="svg('icon-linkedin', 'mr-16')"></span></a>
                        </div>
                    </div>

                    <div v-html="contact.partner.content"></div>
                    <a :href="route('nl.partners')" class="btn btn-accent btn-white-hover text-center mb-xl-12">{{contact.partner.button}} <span v-html="svg('arrow-right', 'arrow-right')" /></a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "pageParts.contact-form-container",

    props: {
        contact: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
